<template>
  <modal
    id="modalAvaliacaoFinal"
    :exibir="exibir"
    titulo="ACADEMICO.AVALIACAO_FINAL"
    :campos="$refs"
    :tamanho="'lg'"
    @fechar="fecharModal"
  >
    <tabela-avaliacao-final
      :form="dadosAvaliacaoFinal"
      @atualizado="atualizarForm"
    />

    <!-- Footer do modal -->
    <template #modal-footer>
      <div class="w-100 d-flex justify-content-between">
        <b-button class="mr-2" variant="secondary" @click="fecharModal">{{
          $t('GERAL.FECHAR')
        }}</b-button>
        <b-button variant="primary" @click="criar">{{
          $t('GERAL.SALVAR')
        }}</b-button>
      </div>
    </template>
  </modal>
</template>
  <script>
// Components
import Modal from '@/components/modal/Modal.vue';
import TabelaAvaliacaoFinal from '@/views/academico/painel-professor/components/ModalAvaliacaoFinal/TabelaAvaliacaoFinal.vue';

// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';

// Services:
import PainelProfessorService from '@/common/services/painel-professor/painel-professor.js';

export default {
  components: {
    Modal,
    TabelaAvaliacaoFinal,
  },
  watch: {
    exibir: 'listarDadosAvaliacaoFinal',
  },
  props: {
    exibir: { type: Boolean, default: false, sortable: true },
    form: { type: Object, default: Object, sortable: true },
  },
  data() {
    return {
      dadosAvaliacaoFinal: [],
    };
  },
  methods: {

    listarDadosAvaliacaoFinal() {
      this.$store.dispatch(START_LOADING);
      PainelProfessorService.listarDadosAvaliacaoFinal(this.form)
        .then(({ data }) => {
          this.dadosAvaliacaoFinal = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },

    atualizarForm(dadosAvaliacaoFinal) {
      this.dadosAvaliacaoFinal = dadosAvaliacaoFinal;
    },

    criar() {
      this.$store.dispatch(START_LOADING);

      const avaliacoesParaEnviar = this.dadosAvaliacaoFinal.filter(
        (aluno) => aluno.valor !== null && aluno.valor !== undefined
      );

      if (avaliacoesParaEnviar.length === 0) {
        mensagem.aviso('Nenhuma nota foi informada para salvar.');
        this.$store.dispatch(STOP_LOADING);
        return;
      }

      PainelProfessorService.criarListaAvaliacaoFinal(
        avaliacoesParaEnviar
      )
        .then(({ data }) => {
          mensagem.sucesso(this.$t('GERAL.SUCESSO'), data.mensagem);
          this.fecharModal();
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
      },

    fecharModal() {
      this.$emit('fechar');
    },
  },
};
</script>
  